module.exports = __webpack_public_path__ + "static/media/222.c54a92ba.jpg";